import { SprievodnyDokumentStatus } from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import {
  fetchSprievodnyDokumentExists,
} from '../../../../client/external/evidencnaaplikacia/sprievodnyDokumentExistsClient';

interface ReturnType {
  sprievodnyDokumentExistsStatus: SprievodnyDokumentStatus;
  sprievodnyDokumentStatus: ClientStatus;
}

// eslint-disable-next-line max-len
export default (legMaterialUuid: string, stadiumUuid: string, sprievodnyDokumentKod: string): ReturnType => {
  const {
    data: sprievodnyDokumentExistsStatus,
    status: sprievodnyDokumentStatus,
  } = useClientFetch(
    fetchSprievodnyDokumentExists,
    [legMaterialUuid, sprievodnyDokumentKod, stadiumUuid],
    [stadiumUuid],
  );
  return {
    sprievodnyDokumentExistsStatus,
    sprievodnyDokumentStatus,
  };
};
